import {
  CartItem,
  Discount,
  Product,
  ShippingData,
  ShippingType,
} from "@/types";
import { AxiosInstance } from "axios";
import { DeepReadonly } from "vue";

export class GroceryApi {
  constructor(private axios: AxiosInstance) {}

  checkout(
    cartItems: DeepReadonly<CartItem[]>,
    discounts: DeepReadonly<Discount[]>,
    shippingType: ShippingType,
    shippingData: DeepReadonly<ShippingData>,
    paymentType: string
  ): Promise<{
    paymentUrl: string;
    successUrl: string;
    reservationId: number;
  }> {
    return this.axios
      .post<{ paymentUrl: string; successUrl: string; reservationId: number }>(
        "/grocery/checkout",
        {
          discount: discounts,
          shipping: {
            ...shippingData,
            type: shippingType,
          },
          cart: cartItems.map((i) => ({
            productId: i.product.id,
            quantity: i.quantity,
          })),
          payment_type: paymentType,
        }
      )
      .then((r) => r.data);
  }

  getProducts(productId?: number): Promise<Product[]> {
    let url = "/grocery/products";

    if (productId !== undefined) {
      url += `/${productId}`;
    }

    return this.axios.get<Product[]>(url).then((r) => r.data);
  }
}
